import React from 'react';
import { greenCheckMarkIcon } from '../../../../../../assets/svg';
import Icon from '../../../../../../generic-components/Icon';
import { STATUS_BADGE_LABELS, BadgeStyles } from './consts';
import {
  isBillStatusPending, isBillStatusPaid, isBillStatusCanceled, isBillStatusAwaitingDetails,
} from '../../utils';

export const getStatusBadgeText = (status: string) => {
  if (isBillStatusPending(status)) return STATUS_BADGE_LABELS.PENDING;
  if (isBillStatusPaid(status)) return STATUS_BADGE_LABELS.PAID;
  if (isBillStatusCanceled(status)) return STATUS_BADGE_LABELS.CANCELED;
  if (isBillStatusAwaitingDetails(status)) return STATUS_BADGE_LABELS.AWAITING_DETAILS;
  return '';
};

export const getIcon = (status: string) => {
  let src = null;
  if (isBillStatusPaid(status)) src = greenCheckMarkIcon;
  if (src) {
    return (<span className={BadgeStyles.ICON}><Icon src={src} /></span>);
  }
  return null;
};

export const getStyle = (status: string) => {
  if (isBillStatusPending(status)) return BadgeStyles.PENDING;
  if (isBillStatusPaid(status)) return BadgeStyles.PAID;
  if (isBillStatusCanceled(status)) return BadgeStyles.CANCELED;
  if (isBillStatusAwaitingDetails(status)) return BadgeStyles.AWAITING_DETAILS;
  return '';
};
